import React, { useEffect, useState } from "react";
import ShowAllStyles from "./ShowAll.styles";
import customTableStyles from "../../../../global/components/CustomTable/customTable.styles";
import {
  Box,
  Button,
  Grid,
  Popover,
  Typography,
  Stack,
} from "@mui/material";
import {
  EmailOutlined,
  LocalPhone,
  WhatsApp,
  LocationOnOutlined,
  CalendarTodayOutlined,
} from "@mui/icons-material";
import YhTable, { YhTableColumn, YhTableCellParams } from "../../../../ui/YhTable";
import YhInput from "../../../../ui/YhInput";
import YhButton from "../../../../ui/YhButton";
import YhModal from "../../../../ui/YhModal";
import { YhDateRangePicker } from "../../../../ui/YhDateTimePicker";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../helpers/methods";

import CustomButton from "../../../../global/components/CustomButton/CustomButton";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/close.svg";

import {
  changeStatusApi,
  changeUserPassword,
  getAllDeactivatedUsers,
  getDateWiseTeam,
} from "./ShowAllService";
import notifiers from "../../../../global/constants/NotificationConstants";
import CustomLoader from "../../../../global/components/CustomLoader/CustomLoader";
import CustomDialog from "../../../../global/components/CustomModal/CustomModal";
import CustomRadioButton from "../../../../global/components/CustomRadioButton/CustomRadioButton";
import customErrorHandler from "../../../../utils/customErrorHandler";
import AddLoan from "../AddLoan/AddLoan";

import { store } from "../../../../utils/store";
import history from "../../../../utils/history";
import urls from "../../../../global/constants/UrlConstants";
import { useHistory } from "react-router-dom";
import { ReactComponent as VerticalDotIcon } from "../../../../assets/icons/verticalDot.svg";
import { hasPrivilegeAction } from "../../../../Shared/AppDrawer/menuPrivileges";

import { getTeamList } from "../../../MetaData/components/MetaList/components/AddTeamMetaList/CreateService";

const officeOf = (row: any) =>
  (Array.isArray(row?.userOffices) ? row.userOffices[0] : row?.userOffices) ||
  {};

const SearchSvg = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <path d="M21 21l-4.35-4.35" />
  </svg>
);

const getInitials = (name: string) => {
  if (!name) return "";
  const parts = name.trim().split(" ");
  if (parts.length > 1) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
};

const getRandomColorClass = (name: string) => {
  const colors = [
    "bg-indigo-50 text-indigo-700",
    "bg-emerald-50 text-emerald-700",
    "bg-amber-50 text-amber-700",
    "bg-sky-50 text-sky-700",
    "bg-rose-50 text-rose-700",
    "bg-violet-50 text-violet-700",
  ];
  if (!name) return colors[0];
  const charCode = name.charCodeAt(0) || 0;
  return colors[charCode % colors.length];
};

const ShowAll = () => {
  const classes = ShowAllStyles;
  const customTableClasses = customTableStyles;
  const privileges = store.getState().auth?.privileges || {};
  const canViewList =
    hasPrivilegeAction(privileges, "Archive Team List", ["view"]) ||
    hasPrivilegeAction(privileges, "Team List", ["view"]);
  const canEditMember =
    hasPrivilegeAction(privileges, "Archive Team List", ["edit"]) ||
    hasPrivilegeAction(privileges, "Team List", ["edit"]);
  const canToggleStatus =
    hasPrivilegeAction(privileges, "Archive Team List", ["delete", "edit"]) ||
    hasPrivilegeAction(privileges, "Team List", ["delete", "edit"]);
  const navigate = useHistory();
  const [search, setSearch] = useState<string>("");
  const [userDataSource, setUserDataSource] = useState<any>([]);
  const [userDataSource1, setUserDataSource1] = useState<any>([]);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [count, setCount] = useState<number>(5);
  const [getAddTeamMetaDataDylog, setGetAddTeamMetaDataDylog] =
    useState<boolean>(false);
  const [fixData, setFixData] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = React.useState(0);
  const userPerPage = 10;
  const userCount = userDataSource.length;
  const pageVisited = pageNumber * userPerPage;
  const displayRows = userDataSource.slice(
    pageVisited,
    pageVisited + userPerPage
  );
  const [userId, setUserId] = useState("");
  const [status, setStatus] = useState("");
  const [apiResponse, setApiResponse] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState({ id: "", status: 0 });
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDialogOpenLoan, setIsDialogOpenLoan] = useState<any>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [userRow_Id, setUserRow_Id] = useState<string>();
  const [rowStatus, setRowStatus] = useState();
  const [filterModel, setFilterModel] = useState({});
  const [teamdata, setTeamData] = useState([]);
  const [passwordReset, setPasswordReset] = useState<any>(false);
  const [passwordResetId, setPasswordResetId] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [selectedDateRange, setSelectedDateRange] = useState<{
    from: string | null;
    to: string | null;
  }>({ from: null, to: null });
  const [openView, setOpenView] = React.useState(false);
  const [metaData, setMetaData] = useState<any>({});
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 25,
    page: 0,
  });
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const isFirstDateRangeEffect = React.useRef(true);
  useEffect(() => {
    tableDataShowHandler();
  }, []);
  useEffect(() => {
    tableDataShowHandler();
  }, [paginationModel]);
  useEffect(() => {
    if (isFirstDateRangeEffect.current) {
      isFirstDateRangeEffect.current = false;
      return;
    }
    tableDataShowHandler();
  }, [selectedDateRange]);
  useEffect(() => {
    tableDataShowHandler();
  }, [search]);
  // get value from Input field
  interface typeOfTeamdataItem {
    team_name: any;
    _id: any;
  }

  const onClickHandler = () => {
    navigate.push(urls.addArchiveTeamViewPath);
  };

  const handleEdit = (id: string) => {
    navigate.push(urls.editArchiveTeamViewPath.replace(":id", id));
  };

  const handleChange = (value: any) => {
    setPaginationModel({
      ...paginationModel,
      pageSize: value.target.value,
      page: 0
    });
  };
  const handleLoan = (id: string, statusVal: any) => {
    setIsDialogOpenLoan(true);
    setUserId(id);
    setStatus(statusVal);
    setAnchorEl(null);
  };

  const handleCloseLoan = () => {
    setIsDialogOpenLoan(false);
    tableDataShowHandler();
  };

  const handleLoanList = (id: string, statusVal: any) => {
    setAnchorEl(null);
    navigate.push(urls.viewArchiveLoanPath.replace(":userId", id));
  };

  const changeStatus = async (status: any, id: any) => {
    try {
      const response = await changeStatusApi(status, id);

      customErrorHandler(response);
      openSuccessNotification(response.message);
      setIsDialogOpen(false);
      tableDataShowHandler();
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const handleViewSalary = (user_id: string) => {
    history.push({
      pathname: urls.salarySlipViewPath,
      state: { fromPage: user_id }, //"64807274ee4348490a2181e1"
    });
  };
  const handleSetPassword = (user_id: string) => {
    setAnchorEl(null);
    setPassword("");
    setPasswordConfirm("");
    setPasswordResetId(user_id);
    setPasswordReset(true);
  };
  const handleSetPasswordClose = () => {
    setPasswordReset(false);
    setPassword("");
    setPasswordConfirm("");
    setPasswordResetId("");
  };
  const handlePopOver = (
    event: React.MouseEvent<HTMLButtonElement>,
    user_id: string,
    status: any
  ) => {
    setAnchorEl(event.currentTarget);
    setUserRow_Id(user_id);
    setRowStatus(status);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const getTeamName = (id: any) => {
    const val: any = teamdata.filter(
      (item: typeOfTeamdataItem) => item._id === id
    );
    const ans = val?.length > 0 ? val[0]?.team_name : "";
    return <Typography sx={classes.rowtext}>{ans}</Typography>;
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const columns: YhTableColumn[] = [
    {
      headerName: "User Details",
      field: "name",
      minWidth: 260,
      flex: 1,
      renderCell: (params: YhTableCellParams) => {
        const name = params.row?.name || "Unknown";
        const initials = getInitials(name);
        const colorClass = getRandomColorClass(name);
        return (
          <div className="flex items-center gap-3 py-2">
            <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-bold ${colorClass}`}>
              {initials}
            </div>
            <div className="flex flex-col">
              <span className="text-sm font-semibold text-[#111827]">
                {name}
              </span>
              {params.row?.employee_id ? (
                <span className="mt-1 w-max rounded bg-emerald-50 px-1.5 py-0.5 text-[11px] font-medium text-emerald-700 ring-1 ring-inset ring-emerald-600/20">
                  {params.row?.employee_id}
                </span>
              ) : null}
            </div>
          </div>
        );
      },
    },
    {
      headerName: "Team Name",
      field: "teamName",
      minWidth: 120,
      renderCell: (params: YhTableCellParams) => {
        const teamId = officeOf(params.row)?.team_id;
        const teamText = teamId ? getTeamName(teamId) : "";

        return (
          <span className="text-[13px] font-medium text-[#374151]">
            {teamText || "—"}
          </span>
        );
      },
    },
    {
      headerName: "Role",
      field: "teamRoleName",
      minWidth: 120,
      renderCell: (params: YhTableCellParams) => {
        const role =
          officeOf(params.row)?.teamRoleName ||
          params.row?.userOffices?.teamRoleName;
        return (
          <span className="text-[13px] font-medium text-[#374151]">
            {role || "—"}
          </span>
        );
      },
    },
    {
      headerName: "Contact Info",
      field: "email",
      minWidth: 220,
      flex: 1,
      renderCell: (params: YhTableCellParams) => (
        <div className="flex flex-col justify-center gap-1.5 py-2">
          {params.row.email && (
            <div className="flex items-center gap-2 text-[13px] font-medium text-[#4B5563]">
              <EmailOutlined sx={{ fontSize: 16 }} />
              <span className="truncate">{params.row.email}</span>
            </div>
          )}
          {params.row.phone && (
            <div className="flex items-center gap-2 text-[13px] font-medium text-[#4B5563]">
              <LocalPhone sx={{ fontSize: 16 }} />
              <span>{params.row.phone}</span>
            </div>
          )}
          {params.row.whatsapp && (
            <div className="flex items-center gap-2 text-[13px] font-medium text-[#4B5563]">
              <WhatsApp sx={{ fontSize: 16 }} />
              <span>{params.row.whatsapp}</span>
            </div>
          )}
        </div>
      ),
    },
    {
      headerName: "Location",
      field: "location",
      minWidth: 180,
      flex: 1,
      renderCell: (params: YhTableCellParams) => {
        const city = params.row.city || "";
        const state = params.row.states?.[0]?.state_name || "";
        const country = params.row.countries?.[0]?.country_name || "";
        return (
          <div className="flex items-start gap-2 py-2 text-[13px] font-medium text-[#4B5563]">
            <LocationOnOutlined sx={{ fontSize: 18, marginTop: "2px" }} className="shrink-0" />
            <div className="flex flex-col gap-0.5">
              <span>{city}{city && state ? ", " : ""}{state}</span>
              <span className="text-[#6B7280]">{country}</span>
            </div>
          </div>
        );
      },
    },
    {
      headerName: "Dates",
      field: "dob",
      minWidth: 160,
      flex: 1,
      renderCell: (params: YhTableCellParams) => {
        const dob = params.row?.dob;
        const doj = officeOf(params.row)?.joining;
        return (
          <div className="flex flex-col justify-center gap-1.5 py-2">
            {dob && (
              <div className="flex items-center gap-2 text-[13px] font-medium text-[#4B5563]">
                <CalendarTodayOutlined sx={{ fontSize: 16 }} />
                <span>DOB: {dob}</span>
              </div>
            )}
            {doj && (
              <div className="flex items-center gap-2 text-[13px] font-medium text-[#4B5563]">
                <CalendarTodayOutlined sx={{ fontSize: 16 }} />
                <span>DOJ: {doj}</span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      headerName: "Leaves",
      field: "LeaveBalance",
      minWidth: 130,
      flex: 1,
      renderCell: (params: YhTableCellParams) => {
        const total = params.row?.leaves?.[0]?.total_leave_available ?? "—";
        const sick = params.row?.leaves?.[0]?.sick_leave_available ?? "—";
        const casual = params.row?.leaves?.[0]?.casual_leave_available ?? "—";
        return (
          <div className="flex flex-col justify-center gap-1 text-[13px] font-medium text-[#4B5563]">
            <span>Total: {total}</span>
            <span>Sick: {sick}</span>
            <span>Casual: {casual}</span>
          </div>
        );
      },
    },
    {
      headerName: "Status",
      field: "status",
      minWidth: 110,
      renderCell: (params: YhTableCellParams) => {
        const raw = params.row?.status;
        const isActive = raw === 1 || raw === "1";
        const label = isActive ? "Active" : "Deactive";
        const chip = (
          <span
            className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[13px] font-medium ${
              isActive
                ? "bg-emerald-50 text-emerald-700"
                : "bg-rose-50 text-rose-700"
            }`}
          >
            <span
              className={`h-1.5 w-1.5 rounded-full ${
                isActive ? "bg-emerald-500" : "bg-rose-500"
              }`}
            />
            {label}
          </span>
        );

        if (!canToggleStatus) return chip;

        return (
          <button
            type="button"
            onClick={() =>
              changeStatus(params.row.status, params.row.user_id || params.row._id)
            }
            className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[13px] font-medium transition ${
              isActive
                ? "bg-emerald-50 text-emerald-700 hover:bg-emerald-100"
                : "bg-rose-50 text-rose-700 hover:bg-rose-100"
            }`}
          >
            <span
              className={`h-1.5 w-1.5 rounded-full ${
                isActive ? "bg-emerald-500" : "bg-rose-500"
              }`}
            />
            {label}
          </button>
        );
      },
    },
    {
      headerName: "Action",
      field: "action",
      minWidth: 60,
      renderCell: (params: YhTableCellParams) => (
        <button
          type="button"
          className="flex h-8 w-8 items-center justify-center rounded-full text-[#9CA3AF] transition hover:bg-[#F3F4F6] hover:text-[#4B5563]"
          onClick={(event: any) =>
            handlePopOver(event, params.row._id, params.row.status)
          }
        >
          <VerticalDotIcon />
        </button>
      ),
    },
  ];

  const tableDataShowHandler = async () => {
    try {
      setApiResponse(true);
      const response3 = await getTeamList();
      setTeamData(response3?.data || []);
      const payload = {
        startDate: selectedDateRange?.from ? selectedDateRange.from : "",
        endDate: selectedDateRange?.to ? selectedDateRange.to : "",
        pageNumber: paginationModel.page,
        pageSize: paginationModel.pageSize,
        userId: store.getState().auth.userId,
        search: search ? search : "",
      };
      const response = await getAllDeactivatedUsers(payload);

      let rows = response?.data;
      let meta = response?.metadata;
      if (Array.isArray(rows) && rows.length === 1 && Array.isArray(rows[0]?.data)) {
        meta = rows[0].metadata;
        rows = rows[0].data;
      }
      if (Array.isArray(meta)) {
        meta = meta[0];
      }

      setMetaData(meta || { total: 0, page: paginationModel.page });
      const list = Array.isArray(rows) ? rows : [];
      setUserDataSource1(list);
      setUserDataSource(list);
      setFixData(list);
    } catch (error: any) {
      setUserDataSource1([]);
      setUserDataSource([]);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    } finally {
      setApiResponse(false);
      setLoading(false);
    }
  };

  // Account status modal

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedUser({ ...selectedUser, status: +event.target.value });
  };

  const dialogHeaderContent = () => {
    return (
      <Box marginTop={1} marginRight={3} sx={{ cursor: "pointer" }}>
        <CloseIcon onClick={() => setIsDialogOpen(false)} />
      </Box>
    );
  };
  const handelDateRange = async (value: any) => {
    // console.log((value[0]),"newvalue")
    // console.log((value[1]),"newvalue")
    console.log(value[0]?.format("DD/MM/yyyy"), "newvalue");
    console.log(value[1]?.format("DD/MM/yyyy"), "newvalue");
    const from = value[0]?.format("DD/MM/yyyy");
    const to = value[1]?.format("DD/MM/yyyy");
    if (from && to) {
      try {
        const response = await getDateWiseTeam(
          store.getState().auth.userId,
          from,
          to
        );
        customErrorHandler(response);
        console.log("response", response);
        let totalTime: any = "0:0";

        const source = response.data.map((userData: any) => {
          return {
            name: (
              <>
                <Typography sx={classes.fullName}>{userData?.name}</Typography>
                {userData?.userOffices[0]?.emp_type ? (
                  <Typography sx={classes.emp_type_btn}>
                    {userData?.userOffices[0]?.emp_type}
                  </Typography>
                ) : (
                  ""
                )}
                {userData?.in_complete && (
                  <Typography sx={classes.Info_btn}>
                    Information incomplete
                  </Typography>
                )}
              </>
            ),

            Designation: (
              <>
                <Typography sx={classes.rowtext}>
                  {userData?.userOffices[0]?.designation}
                </Typography>
                <Typography sx={[classes.rowtext, classes.dipt]}>
                  {userData?.userOffices[0]?.department}
                </Typography>
              </>
            ),
            email: (
              <>
                <Typography sx={classes.rowtext}>
                  <EmailOutlined /> {" "}
                  {userData.email}
                </Typography>
                <Typography sx={classes.rowtext}>
                  <LocalPhone /> {" "}
                  {userData.phone}
                </Typography>
                <Typography sx={classes.rowtext}>
                  <LocalPhone /> {" "}
                  {userData.whatsapp}
                </Typography>
              </>
            ),

            location: (
              <Typography sx={classes.rowtext}>
                {userData.city}, {userData.states[0]?.state_name} <br />{" "}
                {userData.countries[0]?.country_name}{" "}
              </Typography>
            ),
            dob: (
              <>
                {/* <Typography sx={classes.rowtext}>
                Joining Date: {userData?.userOffices[0]?.joining}
              </Typography> */}
                <Typography sx={classes.rowtext}>
                  Birthday: {userData?.dob}
                </Typography>
              </>
            ),

            LeaveBalance: (
              <>
                <Typography sx={classes.rowtext}>
                  Total Leave : {userData?.leaves[0]?.total_leave_available}
                </Typography>

                <Typography sx={classes.rowtext}>
                  Sick Leave: {userData?.leaves[0]?.sick_leave_available}
                </Typography>

                <Typography sx={classes.rowtext}>
                  Casual Leave: {userData?.leaves[0]?.casual_leave_available}
                </Typography>
              </>
            ),

            status: (
              <>
                {privileges &&
                  (privileges?.["Team List"]?.includes("delete") ||
                    privileges?.["Team List"]?.includes("full control")) ? (
                  <Box
                    sx={
                      userData.status == 0
                        ? classes.deActive
                        : classes.activeBtn
                    }
                  >
                    <CustomButton
                      label={userData.status == 0 ? "Deactive" : "Active"}
                      buttonType="primaryBtn"
                      onClick={() => {
                        changeStatus(userData.status, userData.user_id);
                      }}
                    />
                  </Box>
                ) : (
                  ""
                )}
              </>
            ),

            action: (
              <>
                <Box sx={classes.verticalDotButton}>
                  <Button
                    onClick={(event: any) =>
                      handlePopOver(event, userData._id, userData.status)
                    }
                  >
                    <VerticalDotIcon />
                  </Button>
                </Box>
                {/* <Box sx={classes.buttonWrapper}>
                <CustomButton
                  label="Edit"
                  buttonType="iconBtn"
                  onClick={() => {
                    handleEdit(userData._id);
                  }}
                />

                <CustomButton
                  label="Add Loan"
                  buttonType="iconBtn"
                  onClick={() => handleLoan(userData?._id, userData?.status)}
                />

                <CustomButton
                  label="View Salary"
                  buttonType="iconBtn"
                  onClick={() => handleViewSalary(userData?.user_id)}
                />
              </Box> */}
              </>
            ),
          };
        });
        setUserDataSource([...source]);
        const source1 = response.data.map((userData: any) => {
          return userData;
        });
        setUserDataSource1([...source1]);
        setFixData([...source]);
        setApiResponse(false);
      } catch (error: any) {
        setApiResponse(false);
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    }
  };
  const updateDetails = async (type: any) => {
    try {
      if (passwordConfirm.length && passwordConfirm === password) {
        const response2 = await changeUserPassword({
          id: passwordResetId,
          password: password,
        });
        openSuccessNotification(response2.message);

        handleSetPasswordClose();
      } else {
        openErrorNotification("Value Not Matched");
      }
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
  const dialogTitleContent = () => {
    return (
      <>
        <Box sx={classes.content}>
          <Grid container>
            <Grid item xs={12}>
              <Typography sx={classes.pageHeading}>Account Status</Typography>
              <Typography sx={classes.pageSubHeading}>
                Change your account status
              </Typography>
            </Grid>
            {/* <DateRangePicker localeText={{ start: 'Check-in', end: 'Check-out' }} /> */}
            <Grid item xs={12} mt={5}>
              <Typography sx={classes.statusHeading}>Current Status</Typography>

              <Box sx={classes.checkBoxWarapper}>
                <CustomRadioButton
                  value={1}
                  checked={selectedUser.status == 1}
                  onChange={handleRadioChange}
                  label="Active"
                />

                <CustomRadioButton
                  value={0}
                  checked={selectedUser.status == 0}
                  onChange={handleRadioChange}
                  label="Deactive"
                />
              </Box>

              <Box>
                <CustomButton
                  onClick={() => {
                    // handleDeleteAccount();
                  }}
                  label="Delete Account"
                  buttonType="iconBtn"
                  customClasses={{ color: "red" }}
                />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box sx={classes.buttonWrapperDialog}>
                <CustomButton
                  label="Save"
                  onClick={() => { }}
                  buttonType="primaryBtn"
                />
                <CustomButton
                  label="Cancel"
                  onClick={() => {
                    setIsDialogOpen(false);
                  }}
                  buttonType="secondaryBtn"
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </>
    );
  };
  const getShowAllPage = () => {
    const canCreate =
      hasPrivilegeAction(privileges, "Archive Team List", ["create"]) ||
      hasPrivilegeAction(privileges, "Team List", ["create"]);

    return (
      <>
        <div className="flex h-full min-h-0 w-full flex-col overflow-hidden">
          <div className="mb-4 flex shrink-0 flex-wrap items-center justify-between gap-3">
            <div className="min-w-0">
              <h1 className="text-2xl font-bold tracking-tight text-[#111827]">
                Archive Team List
              </h1>
              <p className="mt-1 text-sm text-[#6B7280]">
                Manage your archive team member here.
              </p>
            </div>
            {canCreate ? (
              <button
                type="button"
                onClick={() => onClickHandler()}
                className="inline-flex h-10 shrink-0 items-center gap-2 rounded-xl bg-[#A02448] px-4 text-sm font-semibold text-white shadow-sm transition hover:bg-[#4A4EDB]"
              >
                + Add Team
              </button>
            ) : null}
          </div>

          <div className="mb-4 flex shrink-0 flex-wrap items-center gap-3">
            <div className="w-full max-w-[320px] flex-1">
              <YhInput
                placeholder="Search"
                type="search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                autoFocus={isSearchFocused}
                startAdornment={<SearchSvg />}
                onFocus={() => setIsSearchFocused(true)}
                onBlur={() => setIsSearchFocused(false)}
              />
            </div>
            <div className="ml-auto flex flex-wrap items-center gap-2">
              <span className="text-xs font-medium text-[#6B7280]">Filters</span>
              <YhDateRangePicker
                className="!w-[240px] shrink-0"
                placeholder="MM/DD/YYYY - MM/DD/YYYY"
                value={{
                  from: selectedDateRange?.from || null,
                  to: selectedDateRange?.to || null,
                }}
                onChange={(range) => setSelectedDateRange(range)}
              />
            </div>
          </div>

          <div className="min-h-0 flex-1 overflow-hidden">
            {canViewList ? (
              <YhTable
                columns={columns}
                rows={userDataSource1 || []}
                getRowId={(row) => row.user_id || row._id}
                rowHeight={90}
                loading={apiResponse}
                emptyMessage="No data found"
                className="h-full min-h-0"
                page={paginationModel.page}
                pageSize={paginationModel.pageSize}
                totalRows={metaData?.total || 0}
                onPageChange={(p) =>
                  setPaginationModel((prev) => ({ ...prev, page: p }))
                }
                onPageSizeChange={(s) =>
                  setPaginationModel({ pageSize: s, page: 0 })
                }
              />
            ) : null}

            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              sx={{ top: "10px", left: "-20px" }}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
            >
              <Box sx={classes.innerPopOver}>
                {canEditMember ? (
                  <>
                    <CustomButton
                      label="Edit"
                      buttonType="iconBtn"
                      onClick={() => {
                        handleEdit(userRow_Id ?? "");
                      }}
                    />
                    <CustomButton
                      label="Add Loan"
                      buttonType="iconBtn"
                      onClick={() =>
                        handleLoan(userRow_Id ?? "", rowStatus)
                      }
                    />

                    <CustomButton
                      label="View Loan"
                      buttonType="iconBtn"
                      onClick={() =>
                        handleLoanList(userRow_Id ?? "", rowStatus)
                      }
                    />

                    <CustomButton
                      label="View Salary"
                      buttonType="iconBtn"
                      onClick={() =>
                        handleViewSalary(userRow_Id ?? "")
                      }
                    />
                  </>
                ) : (
                  ""
                )}
                <CustomButton
                  label="Reset Password"
                  buttonType="iconBtn"
                  onClick={() => handleSetPassword(userRow_Id ?? "")}
                />
              </Box>
            </Popover>
          </div>

          {apiResponse && <CustomLoader apiResponse={false} />}
        </div>

        <CustomDialog
          fullScreen={true}
          isDialogOpen={isDialogOpen}
          dialogHeaderContent={dialogHeaderContent()}
          dialogTitleContent={dialogTitleContent()}
        />

        {isDialogOpenLoan && (
          <AddLoan
            isDialogOpenLoan={true}
            handleCloseLoan={handleCloseLoan}
            userId={userId}
            status={status}
          />
        )}
        <YhModal
          open={passwordReset}
          onClose={handleSetPasswordClose}
          width={420}
          title="Reset Password"
          className="!min-h-[280px]"
          footer={
            <div className="flex justify-end gap-2">
              <YhButton
                variant="secondary"
                size="sm"
                onClick={handleSetPasswordClose}
              >
                Cancel
              </YhButton>
              <YhButton
                variant="primary"
                size="sm"
                onClick={() => updateDetails("password")}
              >
                Save
              </YhButton>
            </div>
          }
        >
          <div className="flex min-h-[140px] flex-col gap-4 py-1">
            <YhInput
              autoFocus
              label="Create Password"
              placeholder="Enter password"
              type="password"
              name="createPassword"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <YhInput
              label="Confirm Password"
              placeholder="Confirm password"
              type="password"
              name="confirmPassword"
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
            />
          </div>
        </YhModal>
      </>
    );
  };

  return getShowAllPage();
};

export default ShowAll;
